export enum DashboardCardsEnum {
    EXPORTS = 'Exports',
    ENRICHMENT = 'Enrichment',
    VISITOR_INTEL = 'VisitorIntel',
    INTENT = 'Intent',
    GROWTH_SIGNALS = 'Growth Signals',
    NEW_TECHNOLOGY = 'New Technology',
    ROD = 'ROD',
    NEWS = 'News',
    INTEGRATIONS = 'Integrations',
    REV_DRIVER = 'RevDriver',
    RECOMMENDED_LISTS = 'Recommended Lists',
    SAVED_SEARCHES = 'Saved Searches',
    SESSIONS = 'Sessions',
    SEARCHES = 'Searches',
    ICP = 'ICP'
  }
  
